import styled from '@emotion/styled';

const WidgetAvaliacoesWrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.LfThmBrandSpaceGap400};
`;

export const S = {
  WidgetAvaliacoesWrapper,
};
